import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useWindowWidth } from '@nike/nike-design-system-components';

import OrderDeadlines from '../../orderDeadlines/OrderDeadlines';
import SecEmeaCutover from './SecEmeaCutover';
import SecEmeaCutoverChina from './SecEmeaCutoverChina';
import SecEmeaCutoverAus from './SecEmeaCutoverAus';
import SecEmeaCutoverUS from './SecEmeaCutoverUS';
import Carousel from '../../components/Carousel';
import LoadingAnimation from '../../components/LoadingAnimation';

import { getUserAccount } from '../selectors';
import { getSalesOrg } from '../../gamedayAccount/selectors';
import { deadlinesForAccount } from '../../orderDeadlines/reducer';
import { getOrderDeadlinesForAccount, selectDeadline } from '../../orderDeadlines/actions';

// import { isUSSalesOrg } from '../../util/constants';

const MAX_ORDER_WINDOWS = 3;

export const HomePageCarousel = () => {
  const dispatch = useDispatch();
  const salesOrg = useSelector(getSalesOrg);

  let SECCutoverSlide = <SecEmeaCutover />;

  if (
    [
      '9800', // Greater China
      '9600', // Nike Hong Kong
      '9700' // Nike Taiwan
    ].includes(salesOrg)
  ) {
    SECCutoverSlide = <SecEmeaCutoverChina />;
  }

  if (salesOrg === '8700') {
    SECCutoverSlide = <SecEmeaCutoverAus />;
  }

  if (['1020', '1100'].includes(salesOrg)) {
    SECCutoverSlide = <SecEmeaCutoverUS />;
  }

  const [slides, setSlides] = useState([]);
  // const [carouselHeight, setCarouselHeight] = useState({ smallScreen: '680px', largeScreen: '502px' });

  // const isUSAccount = isUSSalesOrg(salesOrg);
  const userAccount = useSelector(getUserAccount);
  const deadlines = userAccount?.number
    ? useSelector(state => deadlinesForAccount(state, userAccount.number))
    : undefined;

  useEffect(() => {
    const deadlinesHaveLoaded = deadlines !== undefined;
    if (userAccount?.number && !deadlinesHaveLoaded) {
      dispatch(getOrderDeadlinesForAccount({ accountNumber: userAccount.number, limit: MAX_ORDER_WINDOWS }));
    }
    if (deadlines) {
      dispatch(selectDeadline(deadlines[0]));
    }
    if (deadlinesHaveLoaded && deadlines) {
      setSlides([SECCutoverSlide, <OrderDeadlines />, SECCutoverSlide, <OrderDeadlines />]);
    } else if (!deadlinesHaveLoaded) {
      setSlides([<LoadingAnimation size='s' />]);
    } else {
      setSlides([SECCutoverSlide]);
    }
  }, [userAccount, deadlines, salesOrg]);

  const height = useWindowWidth() < 1165 ? '400px' : '350px';

  return <Carousel height={height} slides={slides} timePerSlide={10000} />;
};

export default HomePageCarousel;
